import React, { Component } from 'react';

import classnames from 'classnames';
import Radio from '@mui/material/Radio';
import { WithStyles, withStyles } from '@mui/styles';

import APRadioStyles from './styles/APRadio.style';

interface APRadioProps extends WithStyles<typeof APRadioStyles> {
  isReferralsSearch?: boolean
}

class APRadio extends Component<APRadioProps, {}> {
  render() {
    const {
      classes,
      isReferralsSearch,
      ...otherProps
    } = this.props;

    const ReferralSearchRadioButton = isReferralsSearch ? classes.referralsSearchRadioIcon : '';
    const checked = <div className={classnames(classes.icon, classes.checked, ReferralSearchRadioButton)} />;
    const unchecked = <div className={classnames(classes.icon, classes.unchecked, ReferralSearchRadioButton)} />;

    return (
      <Radio
        icon={unchecked}
        checkedIcon={checked}
        {...otherProps}
      />
    )
  }
}

export default withStyles(APRadioStyles)(APRadio);
